uniform float onOff;
uniform float brightness;
uniform sampler2D uTextureOn;
uniform sampler2D uTextureOff;
varying vec2 vUv;

void main( void ) {
    float uTexScale = 1.4;
    vec2 texUv = vUv;
    texUv.x = mod(texUv.x * uTexScale, 1.0);
    texUv.y = mod(texUv.y * uTexScale, 1.0);

    vec4 textureOffColor = texture2D(uTextureOff, texUv);
    vec4 textureOnColor  = texture2D(uTextureOn, texUv);

    vec4 color = mix(textureOffColor, textureOnColor, onOff);
    color *= brightness;    
    gl_FragColor = vec4(color.xyz, 1.0);
}